import { render, staticRenderFns } from "./PatientLettersList.vue?vue&type=template&id=df30b16c&"
import script from "./PatientLettersList.vue?vue&type=script&lang=js&"
export * from "./PatientLettersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports